'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useState } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import ButtonCircle from 'components/ui/ButtonCircle';
import Text from 'components/ui/Text';

import { useTheme } from 'hooks/useTheme';
import { modulo } from 'utils';
import { blockRootProps } from 'utils';

import CoverSlide from './CoverSlide';

import FlavorPairings from '../shared/FlavorPairings';

import styles from './BlockProductPairingsSlides.module.scss';

const Controls = ({ slideIndex, onPaginate, total }) => {
    const [globalTheme] = useTheme();

    return (
        <div
            className={cx(
                styles.paginationControls,
                styles[`theme--${globalTheme}`],
                {
                    [styles[`paginationControls--show`]]: slideIndex !== 0,
                }
            )}
        >
            <div className={styles.paginationControlsInner}>
                <ButtonCircle
                    theme="small-fill-white"
                    iconType="chevronLeft"
                    onClick={() => {
                        onPaginate(-1);
                    }}
                    className={cx(styles.paginationButton, styles.buttonPrev)}
                />
                <Text
                    as="div"
                    baseTheme="labelSmallAlt"
                    className={styles.paginationCount}
                >
                    {`${Math.max(1, slideIndex)} / ${total}`}
                </Text>
                <ButtonCircle
                    theme="small-fill-white"
                    iconType="chevronRight"
                    onClick={() => {
                        onPaginate(1);
                    }}
                    className={cx(styles.paginationButton, styles.buttonNext)}
                />
            </div>
        </div>
    );
};

Controls.propTypes = {
    slideIndex: PropTypes.number.isRequired,
    onPaginate: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired,
};

const BlockProductPairingsSlides = ({
    __typename,
    anchorId,
    slides,
    flushTop,
    flushBottom,
    textColor,
    ...props
}) => {
    textColor ??= 'cream';

    const [globalTheme] = useTheme();

    const [[page, direction], setPage] = useState([0, 0]);
    const slideIndex = modulo(page, slides.length + 1);

    const paginate = newDirection => {
        setPage([page + newDirection, newDirection]);
    };

    return (
        <div
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.root, styles[`theme--${globalTheme}`], {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.slides}>
                    <div
                        className={cx(styles.slide, {
                            [styles['slide-active']]: slideIndex === 0,
                            [styles['slide-prev']]:
                                direction > 0 && slideIndex === 1,
                        })}
                    >
                        <CoverSlide
                            {...props}
                            onClickStart={() => {
                                paginate(1);
                            }}
                            textColor={textColor}
                        />
                    </div>
                    {slides.map((slide, i) => {
                        return (
                            <div
                                key={i}
                                className={cx(styles.slide, {
                                    [styles['slide-active']]:
                                        slideIndex === i + 1,
                                    [styles['slide-prev']]:
                                        direction > 0
                                            ? slideIndex === i + 2
                                            : slideIndex === i,
                                })}
                            >
                                <FlavorPairings
                                    {...slides[i]}
                                    textColor={textColor}
                                    controls={
                                        <Controls
                                            slideIndex={slideIndex}
                                            onPaginate={paginate}
                                            total={slides.length}
                                        />
                                    }
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

BlockProductPairingsSlides.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
    slides: PropTypes.array,
    textColor: PropTypes.oneOf(['blue', 'cream']),
};

export default BlockProductPairingsSlides;
